import { render } from "./SummaryCardSales.vue?vue&type=template&id=7d68f5db&scoped=true"
import script from "./SummaryCardSales.vue?vue&type=script&lang=js"
export * from "./SummaryCardSales.vue?vue&type=script&lang=js"

import "./SummaryCardSales.vue?vue&type=style&index=0&id=7d68f5db&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d68f5db"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QBtn});
